import { render } from "./CasesStudyPage.vue?vue&type=template&id=0d25421a"
import script from "./CasesStudyPage.vue?vue&type=script&lang=js"
export * from "./CasesStudyPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhouyi/workplace/node/djweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__